import React, { useState, useEffect, useRef } from 'react'
import { Box, Typography, Grid } from '@mui/material'
import myImage1 from '../../assets/images/fonder-ceo.jpg'
import myImage2 from '../../assets/images/cofonder-seo.jpg'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Title from '../Title/Title'

gsap.registerPlugin(ScrollTrigger)

export default function OurTeam() {
  const [open, setOpen] = useState(false)
  const [selectedMember, setSelectedMember] = useState<any>(null)
  const [data] = useState([
    {
      id: 1,
      name: 'Carmi Halachmi',
      position: 'Founder and CEO',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      image: myImage1,
      imagePerson:
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/35af6a41332353.57a1ce913e889.jpg',
    },
    {
      id: 2,
      name: 'Shuki Barak',
      position: 'CoFounder and SEO',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      image: myImage2,
      imagePerson:
        'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/35af6a41332353.57a1ce913e889.jpg',
    },
  ])

  const cardsRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (cardsRef.current) {
      gsap.fromTo(
        cardsRef.current.querySelectorAll('[data-box]'),
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: cardsRef.current,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      )
    }
  }, [data])

  return (
    <Box
      id='our-team-component'
      sx={{
        paddingTop: { xs: '3rem', md: '3rem' },
        position: 'relative',
      }}
    >
      <Title tag='h2'>Founders</Title>
      <Box
        ref={cardsRef}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          gap: 1,
          flexWrap: 'wrap',
        }}
      >
        {data.map((member, idx) => {
          const isActive = selectedMember?.id === member.id && open
          return (
            <Grid item key={member.id} xs={12} md={6} lg={4}>
              <Box
                data-box
                onClick={() => {
                  if (isActive) {
                    setOpen(false)
                    setSelectedMember(null)
                  } else {
                    setSelectedMember(member)
                    setOpen(true)
                  }
                }}
                sx={{
                  transition: 'all 0.5s cubic-bezier(0.4,2,0.6,1)',
                  width: {
                    xs: 'fit-content',
                    md: isActive ? '680px' : 'fit-content',
                  },
                  minWidth: { xs: 'unset', md: '320px' },
                  maxWidth: { xs: 'unset', md: '700px' },
                  height: {
                    xs: isActive ? 'auto' : '340px',
                    md: '340px',
                  },
                  margin: {
                    xs: '0 auto 20px auto',
                    md: '60px 10px 0px 10px',
                  },
                  zIndex: isActive ? 10 : 1,
                  position: 'relative',
                  background: isActive ? '#f8f8f8' : '#a7a7a7',
                  borderRadius: '0.9375rem',
                  overflow: 'hidden',
                  filter: 'grayscale(70%)',
                  padding: '1.06rem',
                  boxShadow: isActive
                    ? '0 8px 32px rgba(0,0,0,0.18)'
                    : undefined,
                  transform: 'none',
                  cursor: 'pointer',
                  '@media (max-width:900px)': {
                    //width: '90vw',
                    minWidth: 'unset',
                    margin: '0 auto 20px auto',
                    position: 'relative',
                    left: '0',
                    right: '0',
                    transform: 'none',
                  },
                  '@media (max-width:599px)': {
                    marginTop: '3.25rem',
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: 2,
                    flexDirection: {
                      xs: 'column',
                      md:
                        isActive && idx % 2 === 0
                          ? 'row'
                          : isActive && idx % 2 === 1
                          ? 'row-reverse'
                          : 'row',
                    },
                  }}
                >
                  <Box
                    sx={{
                      overflow: 'hidden',
                      borderRadius: '0.625rem',
                      position: 'relative',
                      zIndex: 2,
                      width: {
                        xs: '100%',
                        sm: isActive ? '340px' : '100%',
                      },

                      background: '#eaeaea',
                      minWidth: '120px',
                      minHeight: '120px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginInline: 'auto',
                    }}
                  >
                    <img
                      src={isActive ? member.imagePerson : member.image}
                      alt={member.name}
                      style={{
                        width: '100%',
                        height: '340px',
                        objectFit: 'cover',
                        transition: 'filter 0.3s',
                        position: 'relative',
                        margin: 0,
                        padding: 0,
                        display: 'block',
                      }}
                    />
                  </Box>
                  {isActive && (
                    <Box
                      sx={{
                        textAlign: 'center',
                        width: isActive ? 'fit-content' : '100%',
                        userSelect: 'none',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Typography
                        component='h3'
                        sx={{
                          fontSize: 28,
                          fontWeight: 400,
                          color: '#454545',
                        }}
                      >
                        {member.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 18,
                          color: '#505050',
                          mb: 1,
                        }}
                      >
                        {member.position}
                      </Typography>
                      <Typography sx={{ fontSize: '16px', color: '#303030' }}>
                        {member.description}
                      </Typography>
                    </Box>
                  )}
                </Box>
                {/* Имя и должность поверх картинки, если не раскрыто */}
                {!isActive && (
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: '2rem',
                      left: '1.75rem',
                      zIndex: 2,
                      textAlign: 'left',
                      transition:
                        'left 0.5s cubic-bezier(0.4,2,0.6,1), right 0.5s cubic-bezier(0.4,2,0.6,1)',
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#fff',
                        fontFamily: "'Proxima Nova', sans-serif",
                        fontSize: '1rem',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        textAlign: 'left',
                        lineHeight: '1.5625rem',
                      }}
                    >
                      {member.name}
                    </Typography>
                    <Typography
                      sx={{
                        color: '#fff',
                        fontFamily: "'Proxima Nova', sans-serif",
                        fontSize: '0.8rem',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: '0.8rem',
                        textAlign: 'left',
                      }}
                    >
                      {member.position}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>
          )
        })}
      </Box>
    </Box>
  )
}
